module.exports = __webpack_public_path__ + "static/text-72f40aca85e9ee8fc6a51bdd536d5f62.png";